import { mutatorAction } from 'satcheljs';
import getListViewState from '../selectors/getListViewState';

export const setCopilotResultsTableViewIdsMutator: (
    copilotResultsTableViewId: string | undefined, // This is passed in as undefined if the user is just switching between the Focused/Other tab and the copilot results tab is already open (and therefore has been set)
    previousTableViewId: string
) => void = mutatorAction(
    'setCopilotResultsTableViewIdsMutator',
    function setCopilotResultsTableViewIdsMutator(
        copilotResultsTableViewId: string | undefined,
        previousTableViewId: string
    ): void {
        const state = getListViewState();
        if (copilotResultsTableViewId) {
            state.copilotResultsTableViewId = copilotResultsTableViewId;
        }
        state.previousTableViewId = previousTableViewId;
    }
);

export const dismissCopilotResultsTabMutator: () => void = mutatorAction(
    'dismissCopilotResultsTabMutator',
    function dismissCopilotResultsTabMutator(): void {
        const state = getListViewState();
        state.copilotResultsTableViewId = undefined;
        state.previousTableViewId = undefined;
    }
);
